export default function initCollapse() {
  const $collapse = document.querySelectorAll('.collapse');

  $collapse.forEach((item) => {
    if (item.classList.contains('content')) {
      const $contentBlock = item.parentElement;

      if ($contentBlock) {
        item.addEventListener('hidden.bs.collapse', () => {
          $contentBlock.classList.add('collapsed');
        });

        item.addEventListener('shown.bs.collapse', () => {
          $contentBlock.classList.remove('collapsed');
        });
      }
    }
  });
};
